import{jsx as o}from"react/jsx-runtime";import r from"../assets/story-item.module.scss";const t=({description:s})=>o("div",{className:r.storyItem__description,children:s});export{t as StoryItemDescription};
